export const RELATED_WIKIFOLIOS_BOX_TEST_ID = "related-wikifolios-box";
